import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, input } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { HistorialExpedienteDto } from '@models/historialExpediente/historialExpedienteDto';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ButtonActionComponent } from 'src/app/component/button-action/button-action.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonExportFileComponent } from 'src/app/component/button-export-file/button-export-file.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';

@Component({
  standalone: true,
  imports: [AppRolesDirective, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, SinDatosParaMostrarComponent, ButtonNewComponent, SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, CommonModule, FormsModule, MatSortModule, NgxSpinnerModule, FormsModule, ReactiveFormsModule, CommonModule, ButtonNewComponent, ButtonFilterTableComponent, ButtonExportFileComponent, ButtonActionComponent, SinDatosParaMostrarComponent, MatTooltipModule, MatPaginatorModule, MatRippleModule,ButtonCloseDialogComponent],
  selector: 'app-historial-expediente',
  templateUrl: `./historial-expediente.component.html`,
  styleUrl: './historial-expediente.component.css',
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HistorialExpedienteComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: HistorialExpedienteDto[],
    public dialogRef: MatDialogRef<HistorialExpedienteComponent>,

  ) {
    this.data = this.data.sort((a, b) => new Date(b.fechaCambio).getTime() - new Date(a.fechaCambio).getTime());

  }

  ngAfterViewInit() {
    const items = document.querySelectorAll('.timeline-item');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.2 });

    items.forEach(item => observer.observe(item));
  }

  getIconForAction(accion: string): string {
    switch (accion) {
      case 'Agregar':
        return 'add_circle';
      case 'Modifica':
        return 'edit';
      case 'Agrega':
        return 'add';
      default:
        return 'help';
    }
  }

}



